import React from 'react';
import './welcomeMessage.scss';
import PropTypes from 'prop-types';

const WelcomeMessage = ({ isWelcomeDashboard, policyHolderName, petName }) => {
  return (
    <div
      role="contentinfo"
      className="welcome-message-container"
      aria-labelledby="banner-welcome-message"
    >
      <h1 id="banner-welcome-message">
        Welcome {!isWelcomeDashboard && 'back'}
        <br />
        {policyHolderName}
        {petName}
      </h1>
    </div>
  );
};

export default WelcomeMessage;

WelcomeMessage.propTypes = {
  isWelcomeDashboard: PropTypes.bool,
  policyHolderName: PropTypes.string,
  petName: PropTypes.string
};
